// Proxy the default model/type, since they are the same thing to Sanity.

import { CategoriesSchema, CATEGORIES_PROJECTION } from "@components/categories/Categories.model";

export const DigitalTrialCategoriesType = "digital_trial_categories";

export interface DigitalTrialCategoriesSchema extends CategoriesSchema {}

export const DIGITAL_TRIAL_CATEGORIES_PROJECTION = CATEGORIES_PROJECTION;
